import {
  HttpContextToken,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';
import { TOKEN_KEY } from '@common';

export const SUPPRESS_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const httpInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);
  const toast = inject(ToastService);
  const router = inject(Router);

  // SSR 환경에서는 localStorage가 없으므로 가드 처리
  const accessToken = isBrowser ? localStorage.getItem(TOKEN_KEY.ACCESS_TOKEN_KEY) : null;
  const refreshToken = isBrowser ? localStorage.getItem(TOKEN_KEY.REFRESH_TOKEN_KEY) : null;

  if (accessToken && refreshToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
        'x-refresh-token': refreshToken,
      },
    });
  }

  return next(req).pipe(
    catchError((error) => {
      if (isBrowser) {
        if (error.status === 401) {
          localStorage.removeItem(TOKEN_KEY.ACCESS_TOKEN_KEY);
          localStorage.removeItem(TOKEN_KEY.REFRESH_TOKEN_KEY);
        }

        if (error.status === 498) {
          localStorage.removeItem(TOKEN_KEY.ACCESS_TOKEN_KEY);
          localStorage.removeItem(TOKEN_KEY.REFRESH_TOKEN_KEY);
          router.navigateByUrl('/home', { replaceUrl: true });
        }
      }
      if (isBrowser && error.error?.message && !req.context.get(SUPPRESS_ERROR_TOAST)) {
        toast.error(error.error.message);
      }
      return throwError(() => error);
    }),
  );
};
